import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
interface RechartsBarChartProps {
  data: any[];
  height?: number;
  color?: string;
  dataKey?: string;
  xAxisKey?: string;
  yAxisFormatter?: (value: number) => string;
  tooltipFormatter?: (value: number) => [string, string];
}
const RechartsBarChart: React.FC<RechartsBarChartProps> = ({
  data,
  height = 300,
  color = '#3b82f6',
  dataKey = 'value',
  xAxisKey = 'name',
  yAxisFormatter = value => `${value}`,
  tooltipFormatter = value => [`${value}`, dataKey]
}) => {
  return <ResponsiveContainer width="100%" height={height} data-id="element-154">
      <BarChart data={data} margin={{
      top: 5,
      right: 20,
      left: 20,
      bottom: 5
    }} data-id="element-155">
        <CartesianGrid strokeDasharray="3 3" stroke="#888" opacity={0.2} data-id="element-156" />
        <XAxis dataKey={xAxisKey} tick={{
        fontSize: 12
      }} tickLine={false} axisLine={{
        stroke: '#888',
        opacity: 0.4
      }} data-id="element-157" />
        <YAxis tickFormatter={yAxisFormatter} tick={{
        fontSize: 12
      }} tickLine={false} axisLine={{
        stroke: '#888',
        opacity: 0.4
      }} width={60} data-id="element-158" />
        <Tooltip formatter={(value: any) => {
        const [formattedValue, label] = tooltipFormatter(value);
        return [formattedValue, label];
      }} contentStyle={{
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
      }} data-id="element-159" />
        <Bar dataKey={dataKey} fill={color} radius={[4, 4, 0, 0]} data-id="element-160" />
      </BarChart>
    </ResponsiveContainer>;
};
export default RechartsBarChart;